import { Icon } from "../Icon/Icon";
import { ReactElement } from "react";

export type IconButtonProps = {
  active: boolean;
  handleClick: Function;
  ariaLabel?: string;
};

type IconButtonPropsForIcon = {
  caption: string;
  ariaLabel?: string;
  active: boolean;
  icon: ReactElement;
  fgColour: string;
  bgColour: string;
  hasDropShadow?: boolean;
  handleClick: Function;
  useSetWidth?: boolean;
};

export const IconButton = ({
  caption,
  ariaLabel,
  active,
  icon,
  fgColour,
  bgColour,
  handleClick,
  hasDropShadow,
  useSetWidth,
}: IconButtonPropsForIcon) => {
  return (
    <button className="h-full" disabled={!active} aria-label={ariaLabel} onClick={() => (active ? handleClick() : {})}>
      <Icon
        caption={caption}
        icon={icon}
        fgColour={active ? fgColour : "text-white"}
        bgColour={active ? bgColour : "bg-navy-blue-lighter"}
        hasDropShadow={hasDropShadow ?? true}
        useSetWidth={useSetWidth}
      />
    </button>
  );
};

IconButton.defaultProps = { caption: "", fgColour: "text-brand", bgColour: "bg-white", handleClick: () => {} };
